import { Component, inject } from '@angular/core';
import { LeftMenuComponent } from "../../shared/components/left-menu/left-menu.component";
import { RouterOutlet } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogPositionClass } from '../../shared/enums/dialogs.enum';
import { MenuItem } from '../../shared/models/menu-item.model';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'glo-staff',
    imports: [RouterOutlet, LeftMenuComponent],
    templateUrl: './staff.component.html',
    styleUrl: './staff.component.scss'
})
export class StaffComponent {
  dialog: MatDialog = inject(MatDialog);
  assetUrl = environment.assetBaseUrl

  menuItems: MenuItem[] = [
      {
          label: 'Overview',
          link: 'overview',
          icon: this.assetUrl + 'icons/menu-home.svg',
          alt: 'Overview icon',
      },
      {
          label: 'Your Appointments',
          link: 'appointments',
          icon: this.assetUrl + 'icons/menu-list.svg',
          alt: 'Your Appointments icon',
      },
      {
          label: 'Services',
          link: 'services',
          icon: this.assetUrl + 'icons/menu-services.svg',
          alt: 'Services icon',
      },
      {
          label: 'Customer Management',
          link: 'customer-relationship',
          icon: this.assetUrl + 'icons/menu-user.svg',
          alt: 'Customer Relationship icon',
      },
  ];

  openMenuDialog(): void {
    this.dialog.open(LeftMenuComponent, {
      panelClass: DialogPositionClass.left,
      data: { items: this.menuItems }
    });
  }
}
